import useSWR from 'swr'
import fetcher from '~/src/lib/fetcher'
import { GeoData } from '~/src/lib/geo'

const useGeo = () => {
  const { data, error, isLoading } = useSWR<GeoData | undefined | null>(
    '/api/geo',
    fetcher,
    {
      revalidateOnFocus: false,
    }
  )

  return {
    data,
    isLoading,
    isError: error,
  }
}

export default useGeo
